<template>
    <b-card>
        <b-row>
          <b-col cols="auto">
            <b-avatar variant="primary" :text="getAvatarText"></b-avatar>
          </b-col>
          <b-col cols="auto">
            <div>{{content.name}}</div>
            <div>{{content.retail_name_store_name}}</div>
            <div>{{formattedDate}}</div>

          </b-col>
        </b-row>
      <div class="mt-3">
        <viewer :images="content.content.img_list"
                class="viewer" ref="viewer"
        >

          <template #default="scope">
            <b-row>
              <b-col v-for="src in scope.images" :src="src" :key="src">
                <b-img-lazy
                  rounded
                  alt="Rounded image"
                  fluid-grow
                  height=400
                  width=400
                  :src="src"
                  class="pointer hover-3"/>

              </b-col>
            </b-row>
            {{scope.options}}
          </template>
        </viewer>
        <p class="mt-3">{{content.content.caption}}</p>
      </div>
    </b-card>
</template>

<script>
  export default {
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        imgBaseUrl: ''
      }
    },
    computed: {
      getAvatarText () {
        return this.content.name.split(' ').map(name => name[0]).join('')
      },
      formattedDate () {
        let rawDate = this.content.created_at
        return this.$moment(rawDate).format("D MMMM YYYY, h:mm:ss a")
      }
    },
    methods: {
      buildImgUrl (content) {
        if (content['img_list'] && content['img_list'].length > 0) return content['img_list'][0]
      }
    }
  }
</script>


<style scoped>

  .img-tag {
    position: absolute;
    background-color: #20a8d8;
    margin-top: 25px;
    padding: 4px;
  }

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/Trade/StorePublicationContent/NewsCard.vue